import BaseService from './base.service';

class SearchService extends BaseService {
  
  async getInit() {
    const response = await this.get(`search/init`);
    return response.data;
  }
  async search(domain, q, silence, paginator) {
    const response = await this.get('search', {domain, q, silence, ...paginator.toParams()});
    return response.data;
  }
  async getContent(seq) {
    const response = await this.get(`search/${seq}`);
    return response.data;
  }
  async getUserDocument(content, paginator) {
    const response = await this.get(`search/${content.seq}/document`, paginator.toParams());
    return response.data;
  }
  async aggregation(domain, q) {
    const response = await this.get('search/aggregation', {domain, q});
    return response.data;
  }
}

export default new SearchService();